var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', _vm._b({}, 'sub-visual', _vm.visual, false)), _c('div', {
    staticClass: "client-content-wrap"
  }, [_c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('business-intro', _vm._b({}, 'business-intro', _vm.intro, false))], 1)], 1), _c('section', {
    staticClass: "client-section steps"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title word-keep-all"
  }, [_vm._v(" 후원 아동은 성장 단계별 "), _c('br', {
    staticClass: "d-md-none"
  }), _vm._v(" 필요한 도움을 받으며 "), _c('br', {
    staticClass: "d-md-none d-lg-block"
  }), _vm._v(" 자립할 때까지 "), _c('br', {
    staticClass: "d-md-none"
  }), _vm._v(" 함께합니다. ")])]), _c('v-row', _vm._l(_vm.stages, function (stage, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "alt": "",
        "cols": "6",
        "lg": "3"
      }
    }, [_c('v-card', {
      attrs: {
        "color": "transparent",
        "tile": "",
        "flat": ""
      }
    }, [_c('v-img', {
      staticClass: "border-radius-16 mx-auto",
      attrs: {
        "src": stage.image,
        "max-width": "282"
      }
    }), _c('v-card-title', {
      staticClass: "justify-center text-center pb-0 pt-lg-24"
    }, [_c('div', {
      staticClass: "tit tit--sm primary--text"
    }, [_vm._v(" " + _vm._s(stage.title) + " ")])])], 1)], 1);
  }), 1)], 1)], 1), _c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("주요 프로그램")])]), _c('program-list', {
    attrs: {
      "items": _vm.programs
    }
  })], 1)], 1)]), _c('section', [_c('bottom-banner', {
    attrs: {
      "item": _vm.banner
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }